import { ICreditPlanBlockProps } from '@/components/blocks/CreditPlan/CreditPlanBlock';
import { CreditPlanJurisdiction } from '@/components/ui/CreditPlan/util/constants';
import { createContext } from 'react';
import { CreditPlanPanelType } from './CreditPlanProvider';
import { CreditPlanResponseModel } from '@/@types/client-api';

export interface ICreditPlanContext {
  /** open multi-plan side panel */
  openPanel(jurisdiction?: null, content?: ICreditPlanBlockProps): void;
  /** open single plan (generated/generating) side panel */
  openPanel(jurisdiction: string, content?: ICreditPlanBlockProps): void;
  openPanel(
    jurisdiction: string,
    content?: ICreditPlanBlockProps,
    previousType?: CreditPlanPanelType
  ): void;
  closePanel: () => void;
  handlePanelBackButton?: () => void;
  createCreditPlan: (jurisdiction: CreditPlanJurisdiction) => void;
  jurisdictions: CreditPlanJurisdiction[] | undefined;
  isLoading: boolean;
  creditPlans: CreditPlanResponseModel[];
  isPanelOpen: boolean;
}

export const creditPlanContext = createContext<ICreditPlanContext>(
  null as unknown as ICreditPlanContext
);
